import React, { useEffect } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "./vfs_fonts";
import { useSelector } from "react-redux";

import { UserActivityAxios } from "../../../API";

const ProgramCertificateNew = () => {
  const userDetails = useSelector((state) => state.auth.loggedInUser);
  const [showDownload, setShowDownload] = React.useState(false);
  const [userName, setUserName] = React.useState('NAME SURNAME');
  const [programName, setProgramName] = React.useState('PROGRAM NAME');
  const [date, setDate] = React.useState('31-12-2025');

  const [solutionSubmitted, setSolutionSubmitted] = React.useState(false);
  const [isProgramComplete, setIsProgramComplete] = React.useState(false);
  const [avgCompletion, setAvgCompletion] = React.useState(0);

  useEffect(() => {
    setUserName(userDetails.firstName + " " + userDetails.lastName);
    setProgramName(userDetails.programName);
    let offeringEndDate = userDetails.offeringEndDate;
    let offeringStartDate = userDetails.offeringStartDate;

    //genrate date in Aug 8th & Aug 9th, 2024 this format
    let start = new Date(offeringStartDate);
    let end = new Date(offeringEndDate);
    let shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let startDay = start.getDate();
    let startMonth = shortMonths[start.getMonth()];
    let startYear = start.getFullYear();

    let endDay = end.getDate();
    let endMonth = shortMonths[end.getMonth()];
    let endYear = end.getFullYear();

    let output = startMonth + " " + startDay + (startDay % 10 === 1 ? "st" : startDay % 10 === 2 ? "nd" : startDay % 10 === 3 ? "rd" : "th") + " & " + endMonth + " " + endDay + (endDay % 10 === 1 ? "st" : endDay % 10 === 2 ? "nd" : endDay % 10 === 3 ? "rd" : "th") + ", " + endYear;
    
    setDate(output);

    // is program end date is less than current date, then program is complete
    if (end <= new Date()) {
        setIsProgramComplete(true);
    }
    
    getProgramStatus(userDetails.offeringUserId);

  }, [userDetails]);

  useEffect(() => {
    if (isProgramComplete && solutionSubmitted && avgCompletion > 50) {
      setShowDownload(true);
    }
  }, [solutionSubmitted, isProgramComplete, avgCompletion]);

  const getProgramStatus = (id) => {
    UserActivityAxios.get(`/OfferingUserActivity/getuseractivitiesstatus/${id}`)
      .then((res) => {
        if (res.data) {
          setAvgCompletion(res.data.avgCompletion);
          setSolutionSubmitted(res.data.solutionSubmitted);
        }
      })
      .catch((err) => {
        console.log(err);
        setShowDownload(false);
      }
      );
  };

  const downloadCertificate = () => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    pdfMake.fonts = {
        Calibri: {
            normal: "Calibri-Regular.ttf",
            bold: "Calibri-Bold.ttf",
        },
        CalibriLight: {
            normal: "Calibri-Light.ttf",
        },
        ChakraPetchSemiBold: {
            normal: "ChakraPetch-SemiBold.ttf",
        }
    };

    let docDefinition = {
        pageOrientation: "landscape",
        pageSize: { width: 1365, height: 768 },
        pageMargins: [45, 95, 45, 10],
        defaultStyle: {
            font: "Calibri",
            lineHeight: 1.25,
            fontSize: 10,
            columnGap: 5,
        },
        background: [{ image: 'pagebg' ,
        width: 1365,
        height: 768,          
         }],
        content: [Certificate()],
        unbreakable: true,
        styles: {
            name: {
                fontSize: 20,
                bold: true,
                alignment: "center",                
                margin: [0, 0, 0, 0],
            },
            title: {
                fontSize: 16,
                bold: true,
                alignment: "center",
                margin: [0, 0, 0, 0],
            }
        },
        images: {
            pagebg: 'pageBg.png',
            certificateLogo: "certificateLogo.png",         
            line: "blackLine.png",
            greenLine: "greenLine.png",
            signature1: "sign1.png",
            signature2: "sign2.png",
        },
    };

    let fileName = userName + "_" + programName + "_program_certificate.pdf";
    fileName = fileName.replace(/ /g, "_");
    pdfMake.createPdf(docDefinition).download(fileName);
};

const Certificate = () => {
    let result = [];

    result.push({
      table: {
        widths: ['*'],
        heights: [600],
        body: [
          [
            {
              stack: [
                { image: 'certificateLogo', width: 200, alignment: 'center', margin: [0, 0, 0, 30] },
                { text: 'Explore', fontSize: 30, alignment: 'center', margin: [0, 0, 0, 20] },
                { image: 'greenLine', width: 500, alignment: 'center', margin: [0, 0, 0, 20] },
                {
                  text: [
                    'This certificate of participation is proudly presented to ',
                    { text: userName.toUpperCase(), bold: true },
                    ' for the outstanding contribution\n in the ',
                    { text: programName, bold: true },
                    ' held on ',
                    { text: date, bold: true },
                    '.'
                  ],
                  fontSize: 20,
                  alignment: 'center',
                  margin: [0, 0, 0, 40]
                },
                {
                  columns: [
                    {
                      stack: [
                        { image: 'signature1', width: 125, alignment: 'center', margin: [0, 0, 0, 10] },
                        { image: 'line', width: 400, alignment: 'center', margin: [0, 0, 0, 30] },
                        { text: [
                          {text: 'Vineeta Khanna', fontSize: 20, bold: true},
                          '\nSr. Vice President (Dean – Explore)\nDeloitte US-India Offices '], fontSize: 20, alignment: 'center' }
                      ]
                     
                    },
                    {
                      stack: [
                        { image: 'signature2', width: 150, alignment: 'center', margin: [0, 0, 0, 10] },
                        { image: 'line', width: 400, alignment: 'center', margin: [0, 0, 0, 30] },
                        { text: [
                          {text: 'Sarah Elizabeth', fontSize: 20, bold: true},
                          '\nVice President, Learning & Development\nDeloitte US-India Offices'], fontSize: 20, alignment: 'center' }
                      ]
                    }
                  ],
                  margin: [0, 0, 0, 30]
                },
                { text: 'Copyright © 2025 Deloitte Development LLC. All rights reserved.', fontSize: 12, alignment: 'left' }
              ]
            }
          ]
        ]
      },
      layout: 'noBorders'
    });

    return result;
};

  return (
    showDownload ?
      <div className="coupon-card">
        < div className="coupons-main" >
          <div className="coupon-details">
            <i className="fa fa-certificate fa-4 certificate-icon" aria-hidden="true"></i>
            <div className="coupons-info pe-0">
              <h5 className="coupons-title">Program Certificate</h5>
              <div className="coupons-text d-flex align-items-center justify-content-between">
                Congratulations! You have successfully completed the program.
                <button className="cdx-btn" onClick={downloadCertificate}>
                  Download
                </button>
              </div>
            </div>
          </div>

        </div >
      </div > : null

  );
};

export default ProgramCertificateNew;